import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterOutlet, CommonModule, HttpClientModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent implements OnInit {
  LoggedIn = JSON.parse(localStorage.getItem('login') || 'false');
  isMobileMenuOpen: boolean = false;
  isDropdownOpen = false;
  toggleMobileMenu(): void {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }
  constructor(private router: Router) {}

  ngOnInit() {}

  throwError() {
    try {
      throw new Error('Test Error from Angular');
    } catch (error) {
      console.error(error);
    }
  }
}
